var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.923 5.923C-.296 12.142 3.879 23 12.489 23c2.003 0 4.447-.431 5.431-.957 1.397-.748 2.407-.311 4.621 2C25.605 27.241 27 27.756 27 25.688c0-.722-1.356-2.315-3.014-3.54-2.474-1.829-2.832-2.567-2-4.122C25.581 11.31 20.611 3 13 3c-3.258 0-4.784.631-7.077 2.923m4.542.038C2.848 9.014 4.844 20.333 13 20.333A7.33 7.33 0 0 0 20.333 13c0-5.011-5.37-8.842-9.868-7.039",
    fill: "#04546c",
    fillRule: "evenodd"
  })));
};
export default SvgSearch;